import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo.jsx";
import "../style/userForms.css";
import { useSearchParams } from "react-router-dom";
import { globalT } from "../utils/globalUtils.js";
import { resetPassword } from "../service/auth.servide";

export const ForgotForm = () => {
  const navigate = useNavigate();
  const [postErrors, setPostErrors] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [formData, setFormData] = useState({
    password: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    document.querySelector(".m-userform").classList.add("loading");
    setPostErrors(false);
    setConfirmationMessage("");

    try {
      const { data } = await resetPassword({ token, newPassword: formData.password });
      
      if (data.message) {
        document.querySelector(".m-userform").classList.remove("loading");
        setConfirmationMessage(globalT(data.message));

        setTimeout(() => {
          navigate("/login");
        }, 1000);
      }

    } catch (e) {
      const error = e.response.data.message;
      document.querySelector(".m-userform").classList.remove("loading");
      setPostErrors(globalT(error));
    }
  };

  return (
    <div className="m-userform">
      <Logo />
      <div className="m-title">{globalT("Establece tu nueva contraseña")}</div>
      <div className="m-subtitle">{globalT("Introduce tu nueva contraseña a continuación.")}</div>
      {!confirmationMessage && (
        <form className="m-form main-form" onSubmit={handleSubmit}>
          <div className="m-input-group">
            <label>{globalT("Password *")}</label>
            <input
              required
              type="password"
              name="password"
              placeholder={globalT("Escribe aquí tu contraseña")}
              value={formData.password}
              onChange={handleInputChange}
            />
          </div>
          {postErrors && <div className="m-error">{postErrors}</div>}
          <button className="m-button" type="submit">
            {globalT("Confirmar")}
          </button>
        </form>
      )}
      {true && <div className="m-confirmation pt-20">{confirmationMessage}</div>}
    </div>
  );
};
